up.preview('summary', (preview) => {
    up.util.timer(250, function () {
        if (preview.ended)
            return;

        const wrapper: HTMLElement = up.element.get('#checkoutSummary');
        const shippingContent: HTMLElement = up.element.get(wrapper, '.checkout-summary__shipping dd');
        const totalContents = wrapper.querySelectorAll('.checkout-summary-card__totalsummary dd');

        shippingContent.innerText = '-';
        preview.insert(shippingContent, "afterbegin", '<div class="spinner-border spinner-border-sm" role="status"></div>');

        for (var content of Array.from(totalContents)) {
            (content as HTMLElement).innerText = '-';

            if (content.classList.contains('checkout-summary__total--emphasis')) {
                preview.insert(content, "afterbegin", '<div class="spinner-border spinner-border-sm" role="status"></div>');
            }
        }
    })
});